import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0
 * @Time 2021.12.30
 *
 * RAP
 * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=236#6674
 **/
const SearchApiService = {
    /**
     * 查询 侵权待确认| 待审核详情
     * @param data
     */
    getGoodsWaitConfirmDetail(data={}) {
        return request({
            url:  '/service/mg/sticker/track/query-wait-goods-detail',
            method: "POST",
            data
        });
    },
    /**
     * 侵权待确认 提交
     * @param data
     */
    updateWaitConfirmGoods(data={}) {
        return request({
            url:  '/service/mg/sticker/track/submit-wait-confirm-goods',
            method: "POST",
            data
        });
    },
    /**
     * 侵权 待审核 提交
     * @param data
     */
    updateAuditGoods(data={}) {
        return request({
            url:  '/service/mg/sticker/track/audit-goods',
            method: "POST",
            data
        });
    },
    /**
     * 侵权待已确认 和已审核详情
     * @param data
     */
    getGoodsDetail(data={}) {
        return request({
            url:  '/service/mg/sticker/track/query-goods-detail',
            method: "POST",
            data
        });
    },

    /**
     * 填写海关编码提交
     * @param data
     */
    saveCustomsCode(data={}) {
        return request({
            url:  '/service/mg/sticker/track/submit-customs-code',
            method: "POST",
            data
        });
    },
    /**
     * 贴纸设置详情
     * @param data
     */
    getStickerDetail(data={}) {
        return request({
            url:  '/service/mg/sticker/track/sticker-detail',
            method: "POST",
            data
        });
    },
    /**
     * 贴纸设置 操作
     * @param data
     */
    saveSticker(data={}) {
        return request({
            url:  '/service/mg/sticker/track/sticker-save',
            method: "POST",
            data
        });
    },
    /**
     * 证书审核详情
     * @param data
     */
    getCertificateAuditDetail(data={}) {
        return request({
            url:  '/service/mg/sticker/track/certificate-audit-detail',
            method: "POST",
            data
        });
    },
    /**
     * 证书审核详情
     * @param data
     */
    saveCertificateAuditDetail(data={}) {
        return request({
            url:  '/service/mg/sticker/track/certificate-audit-save',
            method: "POST",
            data
        });
    },
    /**
     * 贴纸模板列表
     * @param data
     */
    getStickerTemplateList(data={}) {
        return request({
            url:  '/service/mg/sticker/track/sticker-template-list',
            method: "POST",
            data
        });
    },
    /**
     * 无证书列表
     * @param data
     */
    getNoCertificateList(data={}) {
        return request({
            url:  '/service/mg/sticker/track/goods-no-certificate-list',
            method: "POST",
            data
        });
    },
    /**
     * 无证书列表
     * @param data
     */
    saveNoCertificateGoods(data={}) {
        return request({
            url:  '/service/mg/sticker/track/goods-no-certificate-save',
            method: "POST",
            data
        });
    },

    /**
     * post 接口
     * @param sApi 接口
     * @param callback
     * @returns {Function}
     */
    postHttpAction(sApi,data,sMethod='POST') {
        return request({
            url:  sApi,
            method: sMethod,
            data
        });
    }
};

export default SearchApiService;
